import { FaCheck, FaTimes } from "react-icons/fa";
import './alert.scss';

function AlertSuccess(props) {
    const { children } = props;
    return (
        <div className="alert alert-success">
            <div className="icon">
                <FaCheck />
            </div>
            <div className="body">
                {children}
            </div>
        </div>
    );
}

function AlertError(props) {
    const { children } = props;
    return (
        <div className="alert alert-error my-3">
            <div className="icon">
                <FaTimes />
            </div>
            <div className="body">
                {children}
            </div>
        </div>
    );
}

function AlertInfo(props) {
    const { children } = props;
    return (
        <div className="alert alert-info my-3">
            <div className="icon">
                <FaTimes />
            </div>
            <div className="body">
                {children}
            </div>
        </div>
    );
}

function AlertWarning(props) {
    const { children } = props;
    return (
        <div className="alert alert-warning my-3">
            <div className="icon">
                <FaTimes />
            </div>
            <div className="body">
                {children}
            </div>
        </div>
    );
}

function AlertOutline(props) {
    const { children } = props;
    return (
        <div className="alert alert-outline my-2">

            <div className="body">
                {children}
            </div>
        </div>
    );
}


export {
    AlertSuccess,
    AlertError,
    AlertOutline
}